import React from 'react';
import TagManager from 'react-gtm-module';
import styles from './ChatWindow.module.scss';

export default function ChatWindow({
  onClose,
  onOpen,
  onMouseLeave,
}) {
  const handleOpenClick = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'open_chat_window',
          event_category: null,
          event_label: null,
          value: null,
          slug: null
        }
      });
    }
    onOpen(); // Ejecuta la función original que se pasa como prop
  };

  return (
    <div
      className={styles.chatWindow}
      onClick={e => e.stopPropagation()}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.header}>
        <span className={styles.title}>Zoomlion Perú</span>
        <button className={styles.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>

      <div className={styles.bubble}>
        <p>¡Hola! Estamos para servirle.</p>
        <p>Haga su consulta de nuestros productos sin compromiso.</p>
        <div className={styles.bubbleTail} />
      </div>

      <button className={styles.openBtn} onClick={handleOpenClick}>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png?20220228223904"
          alt="WhatsApp"
        />
        <span>Abrir chat</span>
      </button>
    </div>
  );
}